import * as React from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { GameFeedbackType } from '@domain/constant/acca/test/result/gameFeedbackType';
import classNames from 'classnames/bind';
import styles from './gameResult.module.scss';

const cx = classNames.bind(styles);

const getResult = (feedbackType: GameFeedbackType) => {
  switch (feedbackType) {
    case 'TYPE1':
      return (
        <div className={cx('resultArea')}>
          <div className={cx('statusBox', 'veryGood')}>
            <span className={cx('statusText')}>
              모든 게임의 방법과
              <br />
              목표를 잘 이해하고 있어요.
            </span>
          </div>

          <p className={cx('desc')}>
            전반적으로 게임의 목표를 잘 달성해 나가고 있어요.
            <br />
            게임을 통해 나의 역량을 잘 드러낼 수 있을 거에요!
            <br />
            만약 연습을 더 해보고 싶다면, 튜토리얼 바로가기를 클릭하여 연습을 해 보세요.
          </p>
        </div>
      );
    case 'TYPE2':
      return (
        <div className={cx('resultArea')}>
          <div className={cx('statusBox', 'good')}>
            <span className={cx('statusText')}>
              튜토리얼 확인이
              <br />
              필요한 게임이 있어요.
            </span>
          </div>

          <p className={cx('desc')}>
            대부분의 게임에서 목표를 잘 이해하고 달성하고 있지만,
            <br />
            조금 더 보완이 필요한 게임이 있어요. 아래의 튜토리얼 바로가기를 클릭하여
            <br />
            보완이 필요한 게임의 응시 방법을 꼼꼼하게 확인해 보세요.
          </p>
        </div>
      );
    case 'TYPE3':
      return (
        <div className={cx('resultArea')}>
          <div className={cx('statusBox', 'cheerUp')}>
            <span className={cx('statusText')}>
              게임에 익숙해지기 위해
              <br />
              튜토리얼 확인이 꼭 필요해요.
            </span>
          </div>

          <p className={cx('desc')}>
            방법 이해가 부족해 보이는 게임이 많은 편이에요.
            <br />
            응시 방법을 잘 이해하고 있는지 꼭 확인해 보세요.
            <br />
            게임의 규칙을 꼼꼼하게 읽고 정확하게 응답할 수 있도록 연습해 볼까요?
          </p>
        </div>
      );
  }
};

const GameResult = () => {
  const { accaResultStore } = useResultStore();
  const { accGameResult } = accaResultStore;

  if (!accGameResult) return null;
  const { feedbackType } = accGameResult;

  return (
    <>
      <em className={cx('title')}>전략 게임 분석 결과</em>
      {getResult(feedbackType)}
    </>
  );
};

export default GameResult;
